import {default as Component} from './ImageTextGroupComponent'

const ImageTextGroupComponent = Component

export default ImageTextGroupComponent



// WEBPACK FOOTER //
// ./src/components/ImageTextGroupComponent/index.js